module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "menu_emp"
    }
  }, [_c('ul', _vm._l((_vm.menu), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_vm._v("\n        " + _vm._s(link.name) + "\n        ")])])
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7be4d43e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demoComponents/PlayBackRates.vue
// module id = 165
// module chunks = 1